// import { fetch } from './zk-fetch'
import fetch from './fetch'

/**
 * 扎堆社区帖子发布
 * @param {Object} params 参数
 * @param {String} params.discussion_id 扎堆专题id
 * @param {String} params.content 内容
 * @param {String} params.media_ids 媒体资源id，多个用逗号隔开
 */
export function pushlishPost (params) {
  return fetch.exec('/zd_community_post_publish', params, { method: 'POST' })
}